import { mapState, mapMutations, mapActions } from 'vuex'
import { phoneCode, preLogin, loginBind, getOpenworkwechat } from '@/api/qwAuth'

export default {
  data () {
    return {
      codeTime: 0,
      codeT: null,
      form: {
        phoneNumber: '',
        code: null
      },
      //授权拿到的企业信息
      authData: {},
      loading: null,
      showBindPhone: false
    }
  },
  watch: {},
  mounted () {},
  methods: {
    ...mapActions(['setToken']),
    ...mapMutations(['setTokenExp', 'SETCompanyInfo']),
    //系统内部登录
    async login (token) {
      console.log('登录接口的返回token', token)
      if (token) {
        sessionStorage.setItem('isLoaded', true)
      }

      this.setToken({ token })
      this.setTokenExp({ exp: new Date().getTime() })
      this.$message({
        message: '登录成功',
        type: 'success'
      })
      return true
    },
    //查询当前企业是否配置过企微信息
    getQWConfig () {
      getOpenworkwechat().then((res) => {
        console.log('查询当前企业是否配置过企微信息', res)
        this.endLoading()
        if (res.is_complete) this.$router.push({ path: '/', replace: true })
        else this.$router.push({ path: '/qwAuth/bindCS' })
      })
    },
    //预登录接口
    async toPreLogin () {
      let params = {
        auth_code: this.$route.query.auth_code || this.$route.query.code,
        channel_source: 1
      }
      let res = await preLogin(params).catch((res) => {
        this.logType = res.errcode
        console.log('预登录接口 返回 errcode', this.logType)
        console.log('预登录接口 返回 errcode', this.logData.title[this.logType])
      })
      console.log('//预登录接口', res)
      if (!res) return
      this.authData = res
      this.$store.commit('SETCompanyInfo', res.work_we_chat_resp)
      await this.login(res.token)
      if (res.status) {
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.getQWConfig()
      } else this.showBindPhone = true
    },
    //结束loading
    endLoading () {
      setTimeout(() => {
        this.loading.close()
        this.loading = null
      }, 500)
    },
    /** 短信发送成功后再倒计时（与阿里云滑块通过后请求短信一致） */
    startSmsCountdown () {
      if (this.codeT) {
        clearInterval(this.codeT)
        this.codeT = null
      }
      this.codeTime = 60
      this.codeT = setInterval(() => {
        if (this.codeTime <= 1) {
          this.codeTime = 0
          clearInterval(this.codeT)
          this.codeT = null
          return
        }
        this.codeTime--
      }, 1000)
    },
    /**
     * 阿里云验证码 2.0：在 captchaVerifyCallback 中调用，把 captchaVerifyParam 原样交给后端
     * @returns {Promise<{ captchaResult: boolean, bizResult: boolean }>}
     */
    async requestPhoneCodeAfterCaptcha (captchaVerifyParam) {
      if (!this.form.phoneNumber || this.form.phoneNumber.length < 11) {
        this.$message.error('请输入有效手机号码')
        return { captchaResult: false, bizResult: false }
      }
      if (this.codeTime > 0) {
        return { captchaResult: false, bizResult: false }
      }
      try {
        await phoneCode({
          mobile: this.form.phoneNumber,
          captchaVerifyParam
        })
        this.startSmsCountdown()
        this.$message.success('验证码已发送')
        return { captchaResult: true, bizResult: true }
      } catch (e) {
        return { captchaResult: false, bizResult: false }
      }
    },
    /** 无滑块页面（如全页绑定）直接发短信 */
    getPhoneCode () {
      if (!this.form.phoneNumber || this.form.phoneNumber.length < 11) {
        return this.$message.error('请输入有效手机号码')
      }
      if (this.codeTime) return
      phoneCode({ mobile: this.form.phoneNumber })
        .then(() => {
          this.startSmsCountdown()
          this.$message.success('验证码已发送')
        })
        .catch(() => {})
    },
    //绑定手机
    async bindPhone () {
      if (!this.form.phoneNumber || !this.form.code)
        return this.$message.error({
          message: '请验证信息是否有误',
          type: 'success'
        })
      let params = {
        channel_source: 1,
        mobile: this.form.phoneNumber,
        mobile_verify_code: this.form.code,
        workwechat_corpid: this.authData.workwechat_corpid,
        workwechat_userid: this.authData.workwechat_userid
      }

      const res = await loginBind(params)
      console.log('//绑定手机', res)
      if (res.errcode && res.errcode != 0) this.logType = res.errcode
      else {
        await this.login(res.token)
        this.getQWConfig()
      }
    },
    //前往官网
    goOfficial () {
      window.open('https://www.shopex.cn/solution/wechat_work')
    }
  }
}
